import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function Contests(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#BBEBFA"/>
      <path d="M23 9H21V7H11V9H9C7.9 9 7 9.9 7 11V12C7 14.55 8.92 16.63 11.39 16.94C12.02 18.44 13.37 19.57 15 19.9V23H11V25H21V23H17V19.9C18.63 19.57 19.98 18.44 20.61 16.94C23.08 16.63 25 14.55 25 12V11C25 9.9 24.1 9 23 9ZM11 14.82C9.84 14.4 9 13.3 9 12V11H11V14.82ZM23 12C23 13.3 22.16 14.4 21 14.82V11H23V12Z" fill="#5A5A5A"/>
    </NewsIconWrapper>
  );
}
